export default {
  created: 'created',
  inProgress: 'inProgress',
  completed: 'completed',
  failed: 'failed'
};
